import { create } from "zustand";

export const useDicomStore = create((set) => ({
  // Volume & geometry
  volume: null, // { data: Int16Array[]; rows; cols; depth }
  dicomBounds: null, // { corners: number[8][3] }
  dicomOrientation: null, // { row: [x,y,z], col: [x,y,z] }

  // Crosshair (shared IJK)
  crosshairIJK: null, // { i,j,k,iFloat?,jFloat?,kFloat? }

  // Point linking (viewer <-> model)
  pointLinkingEnabled: false,

  // Setters
  setVolume: (vol) => set({ volume: vol }),
  setDicomBounds: (bounds) => set({ dicomBounds: bounds }),
  setDicomOrientation: (orientation) => set({ dicomOrientation: orientation }),
  setCrosshairIJK: (ijk) => set({ crosshairIJK: ijk }),
  setPointLinkingEnabled: (v) => set({ pointLinkingEnabled: !!v }),

  clearVolume: () =>
    set({
      volume: null,
      dicomBounds: null,
      dicomOrientation: null,
      crosshairIJK: null,
    }),
}));
